import { render, staticRenderFns } from "./ProductPageComponent.vue?vue&type=template&id=d6d73652&"
import script from "./ProductPageComponent.vue?vue&type=script&lang=js&"
export * from "./ProductPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports